import { render } from "./ModalAlterarSenha.vue?vue&type=template&id=0eed9f37"
import script from "./ModalAlterarSenha.vue?vue&type=script&lang=js"
export * from "./ModalAlterarSenha.vue?vue&type=script&lang=js"

import "./ModalAlterarSenha.vue?vue&type=style&index=0&id=0eed9f37&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__